export function getId() {
  return (
    Math.random()
      .toString(36)
      .substr(2, 9) +
    '__' +
    new Date().getTime().toString()
  )
}
